import { useMutation, useQueryClient } from "react-query";
import { studyCenterService } from "@services/study-center";
import { studyCenterQueryKeys } from "./queryKeys";

export const useDeleteEventMutation = () => {
  const queryClient = useQueryClient();

  return useMutation((id: number) => studyCenterService.deleteEvent(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(studyCenterQueryKeys.all);
    },
  });
};
